import React, { lazy, Suspense } from 'react';

import { useIntl } from 'react-intl';

import Spinner from '@atlaskit/spinner/spinner';

import messages from './messages';
import type { RovoAgentCreateModalProps } from './RovoAgentCreateModal';

const LazyRovoAgentCreateModal = lazy(() =>
	import(
		/* webpackChunkName: "@atlaskit-internal_rovo-agent-create-modal" */ './RovoAgentCreateModal'
	).then((m) => ({ default: m.RovoAgentCreateModal })),
);

export const AsyncRovoAgentCreateModal = (props: RovoAgentCreateModalProps): JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Suspense fallback={<Spinner size="small" label={formatMessage(messages.loading)} />}>
			<LazyRovoAgentCreateModal {...props} />
		</Suspense>
	);
};
